<template>
    <p-modal v-if="display" @onClickBG="display=false">
        <div slot="content">
            <div class="title">
                掃描 QR code
            </div>
            <div class="subtitle">
                下載 APP
            </div>
            <canvas id="canvas"></canvas>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';
    import QRCode from 'qrcode';

    export default {
        name: 'RecommendQRCodeModal',
        components: {
            'p-modal': Modal,
        },
        data() {
            return {
                display: false,
            };
        },
        methods: {
            show(url) {
                this.display = true;
                this.$nextTick(() => {
                    let canvas = document.getElementById('canvas')
                    QRCode.toCanvas(canvas, url, {
                        width: 235,
                    });
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;

        span {
            &.red {
                color: #F44336;
                font-weight: 500;
            }
        }
    }

    .content {
        canvas {
            width: 235px;
            height: 235px;
        }
    }
</style>
